module.exports = __webpack_public_path__ + "img/10.9dc9cf47.png";